import HPCComponent from 'components/marketingSite/hiringProcessComparison/HPCComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/dist/client/router';
import { useEffect, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type HiringProcessComparisonPageProps = {
  baseUrl?: string;
};

const parseJSON = (resp: any) => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any) => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const HiringProcessComparisonPage: React.FC<
  HiringProcessComparisonPageProps
> = ({ baseUrl }) => {
  const { t } = useI18n('hiring-process-comparison');

  usePageTrack('Landing - Page Loaded');

  const { locale } = useRouter();

  const [hiringProcess, setHiringProcess] = useState([]);
  const [tips, setTips] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/hiring-processes?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setHiringProcess(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/hiring-process-tips?populate=%2A&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setTips(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/hiring-process-faqs?populate=%2A&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setFaqs(data));
  }, []);

  return (
    <>
      <HeadMetadata
        indexable
        title={t('hiring-process-comparison.page_title')}
        url={APP_URLS.hiringProcessComparison}
        desc={t('hiring-process-comparison.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/hiring_process_comparison.png'
        )}`}
      />
      <HPCComponent content={hiringProcess} tips={tips} faqs={faqs} />
    </>
  );
};

export default HiringProcessComparisonPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'hiring-process-comparison'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
